import {
  ButtonBlock,
  ContentBlock,
  Font,
  List,
} from '@politechdev/blocks-design-system'
import humanizeString from 'humanize-string'
import { AssociatedFlag } from 'performanceReviews/types'
import { getPacketNames } from 'performanceReviews/utils'
import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import i18n from 'translate/i18n'
import { formatToRelativeTimeIntl } from 'utils/dateTime'

const FlagListItem = ({
  flag,
  children,
}: PropsWithChildren<{
  flag: AssociatedFlag
}>) => {
  const { t } = useTranslation()

  return (
    <List.Item>
      <ContentBlock>
        <Font.Copy>{flag.trigger.name}</Font.Copy>
        <Font.Copy variant="hint">{getPacketNames(flag)}</Font.Copy>
      </ContentBlock>
      <ContentBlock>
        <Font.Copy>
          {t(`Flagged {{ relativeDate }}`, {
            relativeDate: formatToRelativeTimeIntl(
              flag.created_at,
              i18n.language
            ),
          })}
        </Font.Copy>
        <Font.Copy variant="hint">{humanizeString(flag.status)}</Font.Copy>
      </ContentBlock>
      <ButtonBlock justify="right">{children}</ButtonBlock>
    </List.Item>
  )
}

export default FlagListItem
